




























import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { isAddress } from 'thor-devkit/dist/cry/address'

@Component
export default class AccountLink extends Vue {
    @Prop(String) private address!: string
    @Prop(Boolean) private abbr!: boolean
    @Prop(Boolean) private icon!: boolean
    @Prop(Boolean) private noLink!: boolean

    private owned = false

    get isValid() { return isAddress(this.address) }

    private created() {
        this.addressChanged()
    }

    @Watch('address')
    private async addressChanged() {
        const addr = this.address
        if (isAddress(addr)) {
            if (addr && this.$connex.vendor.owned) {
                const owned = await this.$connex.vendor.owned(addr)
                if (addr === this.address) {
                    this.owned = owned
                }
            }
        } else {
            this.owned = false
        }
    }
}
